<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div class="flex flex-wrap items-center justify-between gap-4 mb-4">
                <div>
                    <p class="text-lg font-medium">Internal Marks</p>
                    <p class="text-sm text-gray-500">
                        {{ marking.course.title }} - {{ marking.course_year.title }} - {{ marking.semester.title }}
                    </p>
                </div>
                <button-link :href="route('internal.university-marking.list', branch.id)">Back</button-link>
            </div>

            <form @submit.prevent="submitForm">
                <div class="overflow-x-auto border border-gray-200 shadow sm:rounded-lg" v-if="rows.length">
                    <table class="w-full min-w-full divide-y divide-gray-200 whitespace-nowrap">
                        <thead class="bg-gray-50">
                        <tr>
                            <th class="sticky left-0 z-20 min-w-[240px] bg-gray-50 px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">Student</th>
                            <th v-for="subject in subjects" :key="subject.id" class="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                {{ subject.subject.title }}
                                <div class="text-[11px] normal-case text-gray-400">Internal {{ subject.internal_max_marks }}</div>
                            </th>
                        </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="row in rows" :key="row.admission_id">
                            <td class="sticky left-0 z-10 min-w-[240px] bg-white px-4 py-4 text-sm font-medium text-gray-900">
                                {{ row.roll_no }} - {{ row.student_name }}
                            </td>
                            <td v-for="mark in row.marks" :key="`${row.admission_id}-${mark.subject_id}`" class="px-4 py-4 text-sm">
                                <input type="number" min="0" :max="mark.internal_max_marks" step="0.01" class="w-28 border-gray-300 rounded-md shadow-sm text-sm" v-model="mark.internal_marks"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="py-4 overflow-hidden text-center border-b border-gray-200 shadow sm:rounded-lg" v-else>
                    No students found
                </div>

                <div class="flex items-center gap-4 mt-4" v-if="rows.length">
                    <breeze-button :disabled="form.processing">Submit Internal Marks</breeze-button>
                    <span v-if="form.recentlySuccessful" class="text-green-600">Marks saved.</span>
                </div>
                <exception />
            </form>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeButton from '@/Components/Button'
import ButtonLink from '@/Components/ButtonLink'
import Loading from '@/Components/Loading'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Internal,
        BreezeButton,
        ButtonLink,
        Loading,
        Exception,
    },
    props: ['branch', 'marking', 'subjects', 'rows'],
    data() {
        return {
            form: useForm({
                marks: [],
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.marks = this.rows.flatMap((row) => row.marks.map((mark) => ({
                admission_id: row.admission_id,
                subject_id: mark.subject_id,
                internal_marks: mark.internal_marks,
            })));
            this.form.put(route('internal.university-marking.store', [this.branch.id, this.marking.id]), {
                preserveScroll: true,
            });
        },
    },
}
</script>
